import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=13afa6ae&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13afa6ae')) {
      api.createRecord('13afa6ae', component.options)
    } else {
      api.reload('13afa6ae', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=13afa6ae&", function () {
      api.rerender('13afa6ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-215OP8wnjroKb/JS/offershelp.vue"
export default component.exports